function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classnames from 'classnames';
import React, { useContext, useRef, useState } from 'react';
import { ThemeContext, ThemeProvider, useTheme } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import { Breakpoints } from "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import { TableLooks } from "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import { Caption } from "../standard-table/caption.js";
import { StandardTBody } from "../standard-table/standard-tbody.js";
import { Table } from "../standard-table/table.js";
import { Td } from "../standard-table/td.js";
import { TFoot } from "../standard-table/tfoot.js";
import { Th } from "../standard-table/th.js";
import { THead } from "../standard-table/thead.js";
import { Tr } from "../standard-table/tr.js";
import { DndHandleTd } from "./dnd-handle-td.js";
import { DndTableDragContext } from "./dnd-table-drag-context.js";
import { DndTr } from "./dnd-tr.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/** The "rowKey" used for the handle column */
var DND_HANDLE_ROW_KEY = 'handle';
var UnstyledDndTable = function UnstyledDndTable(props) {
  var _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [Breakpoints.Sm] : _props$breakpoints,
    caption = props.caption,
    captionProps = props.captionProps,
    colGroup = props.colGroup,
    columns = props.columns,
    empty = props.empty,
    emptyContent = props.emptyContent,
    emptyTrProps = props.emptyTrProps,
    error = props.error,
    errorContent = props.errorContent,
    errorTrProps = props.errorTrProps,
    footer = props.footer,
    footerContent = props.footerContent,
    _props$hover = props.hover,
    hover = _props$hover === void 0 ? true : _props$hover,
    id = props.id,
    _props$loaderLabel = props.loaderLabel,
    loaderLabel = _props$loaderLabel === void 0 ? '' : _props$loaderLabel,
    loaderTrProps = props.loaderTrProps,
    loading = props.loading,
    _props$look = props.look,
    look = _props$look === void 0 ? TableLooks.Default : _props$look,
    maxHeight = props.maxHeight,
    rows = props.rows,
    _props$scrollX = props.scrollX,
    scrollX = _props$scrollX === void 0 ? true : _props$scrollX,
    scrollY = props.scrollY,
    showCaption = props.showCaption,
    tableProps = props.tableProps,
    tbodyProps = props.tbodyProps,
    tdProps = props.tdProps,
    tfootProps = props.tfootProps,
    thProps = props.thProps,
    theadProps = props.theadProps,
    trProps = props.trProps;
  var format = props.format || id;
  /*
  * We need to have unique keys of each row so that when they are shifted around React re-renders them properly,
  * otherwise React only re-renders the contents instead of the entire <tr> DOM element because it thinks only the
  * values in that array element's object have changed rather than the element's actual position.
  *
  * As rows don't have unique identifiers, a WeakMap is used to store a random identifier with the row's object
  * reference as the key. A random identifer was chosen over using the start index of the row because if the rows prop
  * changes in size many times then index collisions can occur.
  */
  var rowToIdMapRef = useRef(new WeakMap());
  /**
  * As WeakMaps are not enumerable, we need a Map of row IDs to StandardTableRow.
  */
  var rowIdToRowMapRef = useRef(new Map());
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredRowIndex = _useState2[0],
    setHoveredRowIndex = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    dragData = _useState4[0],
    setDragData = _useState4[1];
  var isDragging = !!dragData;
  var _useTheme = useTheme(),
    table = _useTheme.table;
  var trHoverBackgroundColor = table[look].trHoverBackgroundColor;
  var moveRow = function moveRow(dragRowId, hoverRowId) {
    var rowIdToRowMap = rowIdToRowMapRef.current;
    var dragRow = rowIdToRowMap.get(dragRowId);
    var hoverRow = rowIdToRowMap.get(hoverRowId);
    if (!dragRow || !hoverRow) {
      // Failed to look up at least one row with its ID, this shouldn't happen unless the ID is invalid.
      console.warn('DndTable: moveRow called but a row is undefined after looking up by rowId');
      return;
    }
    var dragRowIndex = rows.indexOf(dragRow);
    var hoverRowIndex = rows.indexOf(hoverRow);
    props.moveRow(dragRowIndex, hoverRowIndex);
    setHoveredRowIndex(hoverRowIndex);
  };
  var onRowDropped = function onRowDropped(event, format, dragData) {
    var rowIdToRowMap = rowIdToRowMapRef.current;
    var droppedRow = rowIdToRowMap.get(dragData.rowId);
    if (!droppedRow) {
      // Failed to look up the dropped row with its ID, this shouldn't happen unless the ID is invalid.
      console.warn('DndTable: onRowDropped called but the dropped row is undefined after looking up by rowId');
      return;
    }
    props.onRowDropped(event, format, droppedRow, rows.indexOf(droppedRow));
  };
  var generateRowId = function generateRowId(row) {
    var newId = Math.floor(Math.random() * Math.pow(10, 16));
    rowToIdMapRef.current.set(row, newId);
    rowIdToRowMapRef.current.set(newId, row);
    return newId;
  };
  var columnsLength = columns.length;
  var rowsLength = rows.length;
  var isEmpty = empty !== null && empty !== void 0 ? empty : rowsLength === 0;
  return /*#__PURE__*/React.createElement(DndTableDragContext.Provider, {
    value: {
      data: dragData
    }
  }, /*#__PURE__*/React.createElement(Table, _extends({}, tableProps, {
    breakpoints: breakpoints,
    empty: isEmpty,
    error: error,
    footer: footer,
    hover: false,
    id: id,
    loading: loading,
    look: look,
    maxHeight: maxHeight,
    scrollX: scrollX,
    scrollY: scrollY
  }), /*#__PURE__*/React.createElement(Caption, _extends({}, captionProps, {
    breakpoints: breakpoints,
    showCaption: showCaption
  }), caption), colGroup && colGroup, /*#__PURE__*/React.createElement(THead, _extends({}, theadProps, {
    breakpoints: breakpoints
  }), /*#__PURE__*/React.createElement(Tr, _extends({}, trProps, {
    breakpoints: breakpoints,
    look: look
  }), columns.map(function (column, columnIndex) {
    return /*#__PURE__*/React.createElement(Th, _extends({}, thProps, {
      breakpoints: breakpoints,
      key: "".concat(id, "-th-").concat(columnIndex),
      centered: column.centered,
      scope: "col",
      style: {
        maxWidth: column.maxWidth,
        minWidth: column.minWidth,
        width: column.width
      },
      title: column.headingTitle
    }), column.children);
  }))), /*#__PURE__*/React.createElement(StandardTBody, _extends({}, tbodyProps, {
    breakpoints: breakpoints,
    columnsLength: columnsLength,
    empty: isEmpty,
    emptyContent: emptyContent,
    emptyTrProps: emptyTrProps,
    error: error,
    errorContent: errorContent,
    errorTrProps: errorTrProps,
    loaderLabel: loaderLabel,
    loaderTrProps: loaderTrProps,
    loading: loading,
    style: {
      cursor: isDragging ? 'grabbing' : 'grab'
    }
  }), rows.map(function (row, rowIndex) {
    var rowId = rowToIdMapRef.current.get(row) || generateRowId(row);
    var isRowHovered = !isDragging && hoveredRowIndex === rowIndex;
    return /*#__PURE__*/React.createElement(DndTr, _extends({}, trProps, {
      breakpoints: breakpoints,
      format: format,
      key: "".concat(id, "-tr-").concat(rowToIdMapRef.current.get(row)),
      look: look,
      moveRow: moveRow,
      onDropped: onRowDropped,
      onMouseEnter: function onMouseEnter() {
        return setHoveredRowIndex(rowIndex);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredRowIndex(undefined);
      },
      rowId: rowId,
      setDragData: setDragData,
      style: {
        backgroundColor: hover && isRowHovered && trHoverBackgroundColor || 'transparent'
      }
    }), columns.map(function (column, columnIndex) {
      var _classnames;
      var TdComponent = column.rowKey === DND_HANDLE_ROW_KEY ? DndHandleTd : Td;
      var handleProps = column.rowKey === DND_HANDLE_ROW_KEY ? {
        showHandle: isRowHovered
      } : {};
      return /*#__PURE__*/React.createElement(TdComponent, _extends({}, tdProps, handleProps, {
        className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(column.tdClassName), !!column.tdClassName), _defineProperty(_classnames, "".concat(tdProps === null || tdProps === void 0 ? void 0 : tdProps.className), !!(tdProps !== null && tdProps !== void 0 && tdProps.className)), _classnames)),
        key: "".concat(id, "-td-").concat(columnIndex),
        breakpoints: breakpoints,
        centered: column.centered,
        ellipsis: column.ellipsis,
        heading: column.heading,
        style: {
          maxWidth: column.maxWidth,
          minWidth: column.minWidth,
          width: column.width
        },
        title: column.cellTitle
      }), row[column.rowKey]);
    }));
  })), footer && footerContent && /*#__PURE__*/React.createElement(TFoot, _extends({}, tfootProps, {
    breakpoints: breakpoints
  }), /*#__PURE__*/React.createElement(Tr, _extends({}, trProps, {
    breakpoints: breakpoints,
    look: look
  }), /*#__PURE__*/React.createElement(Td, _extends({}, tdProps, {
    breakpoints: breakpoints,
    colSpan: columnsLength
  }), footerContent)))));
};
/**
 * A table component that supports drag and drop rearranging of rows.
 *
 * Required fields include `id`, `caption`, `columns`, `rows`, `moveRow`, `onRowDropped`.
 *
 * `id` should be a unique identifer for the table. Optionally, a `format` prop can be passed that will be used
 * for the DataTransfer format name during drag and drop. By default it is set to the value of `id`.
 *
 * `caption` is the title displayed above the table.
 *
 * `columns` is an array of `StandardTableColumn` describing the columns in the table. Optionally, a handle column can
 * be added with this definition:
 * ```
 * {
 *   children: '',
 *   heading: '',
 *   rowKey: DND_HANDLE_ROW_KEY,
 *   tdClassName: 'handle'
 * }
 * ```
 *
 * `rows` is an array of `StandardTableRow` describing the rows in the table. If elected to add a handle column, the
 * contents of the handle column can optionally be specified with `[DND_HANDLE_ROW_KEY]: children` key/value pair.
 *
 * `moveRow` is called whenever the row being dragged is moved over another row in the table. It is expected this
 * implementation updates the rows array passed to the component. For example, with `rows` in a state variable in the
 * consumg component the array can be updated with the following implementation:
 * ```
 * const moveRow = (dragRowIndex: number, hoverRowIndex: number): void => {
 *   setRows((prevRows) => {
 *     const newRows = [...prevRows];
 *     const theRow = newRows.splice(dragRowIndex, 1)[0];
 *     newRows.splice(hoverRowIndex, 0, theRow);
 *     return [...newRows];
 *   });
 * };
 * ```
 *
 * `onRowDropped` is called when either the `drop` or `dragend` event is triggered, whichever comes first. This gives
 * notification that the dragging operation is concluded. Post-dragging operations shuold be done here.
 * ```
 * const onRowDropped = (
 *   event: DragEvent,
 *   format: DragAndDropFormats | string,
 *   row: StandardTableRow,
 *   index: number
 * ): void => {
 *   // dragging complete, persist changes, etc.
 * }
 * ```
 *
 * @param props DndTableProps
 * @returns FunctionComponent<DndTableProps>
 */
var DndTable = function DndTable(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(UnstyledDndTable, _extends({}, props)));
};
export { DND_HANDLE_ROW_KEY, DndTable };